export const SET_NAME = "setName";
export const SET_ROLE = "setRole";
export const SET_LOGIN = "setLogin";
export const SET_FULL_NAME = "setFullName";
export const SET_ID = "setId";
